export const regexpOnlyNumber = (value: string) =>
    /^[ !+,-./\\()*:;#%<=>"$'&?@A-Z[\]^_`a-z{|}~А-ЯЁа-яё№«»－—–−‘’]+$/.test(value);
